// DROP DOWN CARD
tetloose.card = function() {
    var $card = $('[rel=js-card]'),
        $closeCard = $('[rel=js-card__detail-close]');

    if ($card.length) {

        $card.on('click', function(e) {
            e.stopPropagation();

            var $t = $(this),
                $detail = $t.find('[rel=js-card__detail]');

            tetloose.closeCard();
            tetloose.openCard($t, $detail);
        });

        $closeCard.on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            tetloose.closeCard();
        });
    }

    tetloose.openCard = function(elm, detail) {
        elm.addClass('is-active');
        setTimeout(function () {
            var $height = detail.outerHeight();
            elm.css('padding-bottom', $height);
        }, 1);

        setTimeout(function () {
            var $offset = elm.offset().top;
            $('html, body').animate({
                scrollTop: $offset - $mastHead.outerHeight()
            }, 100);
        }, 800);
    }

    tetloose.closeCard = function() {
        $card.removeClass('is-active');
        setTimeout(function () {
            $card.not( ".is-active" ).attr('style','');
        }, 200);
    }
}
